import {ExpandCollapseButton} from '@hconnect/uikit/src/lib2'
import {Box, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {TabTypeDto} from '../../types'
import {InteractiveSubmitButton} from '../InteractiveSubmitButton'

type Props = {
  dataFieldsCount: number
  tabType: TabTypeDto
  showDataFieldsCount: boolean
  isDirty: boolean
  isValid: boolean
  isSubmitting: boolean
  allExpanded: boolean
  isSubmitButtonVisible: boolean
  isExpandCollapseAllButtonVisible: boolean
  toggleExpandCollapseAll: () => void
}

export const SlaKpiTabsValuesTableHeader = ({
  dataFieldsCount,
  tabType,
  showDataFieldsCount,
  isSubmitButtonVisible,
  isExpandCollapseAllButtonVisible,
  isDirty,
  isValid,
  isSubmitting,
  allExpanded,
  toggleExpandCollapseAll
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
      mt={showDataFieldsCount ? 0 : 2}
      data-test-id={`tabvalues-table-header-container-${tabType}`}
    >
      <Box data-test-id={`tabvalues-table-header-${tabType}`}>
        <Typography variant="h3">{t(`tabs.${tabType}`)}</Typography>
        {showDataFieldsCount && <Box>{`${dataFieldsCount} ${t('label.totalDataFields')}`}</Box>}
      </Box>
      <Stack direction="row" gap={1}>
        {isExpandCollapseAllButtonVisible && (
          <ExpandCollapseButton
            collapseLabel={t('action.collapseAll')}
            expandLabel={t('action.expandAll')}
            expanded={allExpanded}
            onClick={toggleExpandCollapseAll}
            data-test-id="expand-collapse-button"
          />
        )}

        {isSubmitButtonVisible && (
          <InteractiveSubmitButton
            isValid={isValid}
            isDirty={isDirty}
            isSubmitting={isSubmitting}
          />
        )}
      </Stack>
    </Stack>
  )
}
